import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Alert, Col, Row } from 'reactstrap';
import {
  extractIds,
  getCurrencySuffix,
  getLocalizedName,
  isAdminMode as _isAdminMode,
  anyConfigRequiresAdditionMapping,
} from '../../../../utility/util/util.service';
import { AvForm } from 'availity-reactstrap-validation';
import LocalizedNameField from '../../form/fields/LocalizedNameField';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import LocalizedDescriptionField from '../../form/fields/LocalizedDescriptionField';
import TaxInhouseField from '../../form/fields/TaxInhouseField';
import { connect } from 'react-redux';
import IngredientsField from '../../form/fields/IngredientsField';
import AllergensField from '../../form/fields/AllergensField';
import PreferencesField from '../../form/fields/PreferencesField';
import {
  closeModalSafely,
  getTranslationsCollapsable,
  handleSubmit,
} from './create-or-edit-addition.service';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import {
  execOnSuccess,
  setIsCreateAdditionModalOpen,
  setIsEditAdditionModalOpen,
} from '../../../../redux/modal/modal.actions';
import {
  fetchAdditionGroups,
  fetchFoodItemAdditions,
  fetchItemDatas,
  fetchMenuEntries,
  fetchMenuItems,
} from '../../../../redux/store/store.actions';
import KcalField from '../../form/fields/KcalField';
import PosIntegrationRefField from '../../form/fields/PosIntegrationRefField';
import AdditivesField from '../../form/fields/AdditivesField';
import TaxTakeawayField from '../../form/fields/TaxTakeawayField';
import Collapse from '../../collapsables/collapse/collapse.component';
import LabeledToggle from '../../form/LabeledToggle';
import AdditionGroupsField from '../../form/fields/AdditionGroupsField';
import { basePatchQuery } from '../../../../utility/sb-api/sb-api.service';
import { getOrderConditionsCollapsable } from '../modals.service';
import FormattedNumberField from '../../form/fields/FormattedNumberField';
import { useRef } from 'react';
import DropdownField from '../../form/fields/DropdownField';

const CreateOrEditItemAdditionModal = ({
  isCreateAdditionModalOpen,
  isEditAdditionModalOpen,
  createAdditionModalData,
  editAdditionModalData,
  allAllergens,
  allPreferences,
  allIngredients,
  intl,
  store,
  allAdditives,
  additionGroups,
  foodItemAdditions,
  me,

  fetchFoodItemAdditions,
  setIsCreateAdditionModalOpen,
  setIsEditAdditionModalOpen,
  fetchAdditionGroups,
  fetchMenuItems,
  fetchItemDatas,
  fetchMenuEntries,
}) => {
  const isAdminMode = _isAdminMode(me, store?.slug);
  const [targetAddition, setTargetAddition] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isTranslationsOpen, setIsTranslationsOpen] = useState(false);
  const [
    isItemAdditionGroupEntryOpen,
    setIsItemAdditionGroupEntryOpen,
  ] = useState(false);
  const [isPreSelected, setIsPreSelected] = useState(false);
  const [isOrderConditionsOpen, setIsOrderConditionsOpen] = useState(false);
  const [targetOrderConditions, setTargetOrderConditions] = useState([]);
  const [isAddOrderConditionOpen, setIsAddOrderConditionOpen] = useState(false);
  const [selectedOrderCondition, setSelectedOrderCondition] = useState(null); //we have to put this here because we don't have access to hooks in modals.service
  const [newOrderCondition, setNewOrderCondition] = useState({
    isActive: true,
    priority: 10,
    minTotal: 0,
    maxTotal: null,
    minQty: 0,
    maxQty: null,
    limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
    classes: ['inhouse', 'takeaway'],
  });
  const [
    isOrderConditionsGroupEntryOpen,
    setIsOrderConditionsGroupEntryOpen,
  ] = useState(false);
  const [
    targetGroupEntryOrderConditions,
    setTargetGroupEntryOrderConditions,
  ] = useState([]);
  const [
    isAddOrderConditionGroupEntryOpen,
    setIsAddOrderConditionGroupEntryOpen,
  ] = useState(false);
  const [
    newOrderConditionGroupEntry,
    setNewOrderConditionGroupEntry,
  ] = useState({
    isActive: true,
    priority: 10,
    minTotal: 0,
    maxTotal: null,
    minQty: 0,
    maxQty: null,
    limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
    classes: ['inhouse', 'takeaway'],
  });
  const [isActive, setIsActive] = useState(true);

  const isOpen = isCreateAdditionModalOpen || isEditAdditionModalOpen;
  const isEditMode = isEditAdditionModalOpen;
  const { additionId, groupEntry, additionGroup } =
    (isEditMode ? editAdditionModalData : createAdditionModalData) || {};

  const addition = foodItemAdditions?.find(
    (addition) => addition?.id === additionId,
  );
  const formRef = useRef(null);

  const closeModal = () => {
    setIsOrderConditionsOpen(false);
    setIsAddOrderConditionOpen(false);
    setTargetAddition({});
    setTargetOrderConditions([]);
    setIsItemAdditionGroupEntryOpen(false);
    setIsAddOrderConditionGroupEntryOpen(false);
    setTargetGroupEntryOrderConditions([]);
    setSelectedOrderCondition(null);
    setIsPreSelected(false);
    setIsOrderConditionsGroupEntryOpen(false);
    setNewOrderConditionGroupEntry({
      isActive: true,
      priority: 10,
      minTotal: 0,
      maxTotal: null,
      minQty: 0,
      maxQty: null,
    limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
      classes: ['inhouse', 'takeaway'],
    });
    setNewOrderCondition({
      isActive: true,
      priority: 10,
      minTotal: 0,
      maxTotal: null,
      minQty: 0,
      maxQty: null,
    limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
      classes: ['inhouse', 'takeaway'],
    });
    isCreateAdditionModalOpen
      ? setIsCreateAdditionModalOpen(false)
      : setIsEditAdditionModalOpen(false);
  };
  const userLocale = intl?.locale;
  const _closeModalSafely = () => closeModalSafely(isSubmitting, closeModal);
  const _handleSubmit = (event, errors, values) =>
    handleSubmit(
      event,
      errors,
      values,
      { ...targetAddition, isActive },
      isEditMode,
      setIsSubmitting,
      setTargetAddition,
      closeModal,
      () => {
        (isEditMode && groupEntry
          ? basePatchQuery(
              'manager/stores/' +
                store?.id +
                '/item-addition-group-entries/' +
                groupEntry?.id,
              {
                isPreSelected: isPreSelected,
                orderConditions: isAddOrderConditionGroupEntryOpen
                  ? [
                      ...(targetGroupEntryOrderConditions || []),
                      newOrderConditionGroupEntry,
                    ]
                  : targetGroupEntryOrderConditions,
              },
            )
          : Promise.resolve()
        ).then(async () => {
          const menuId = store?.menu?.id;
          const storeId = store?.id;
          await Promise.all([
            fetchFoodItemAdditions(isAdminMode, menuId, undefined, storeId),
            fetchMenuItems(isAdminMode, menuId, undefined, storeId),
            fetchItemDatas(isAdminMode, menuId, undefined, storeId),
          ]);
          await fetchAdditionGroups(isAdminMode, menuId, undefined, storeId);
          await fetchMenuEntries(menuId, isAdminMode, undefined, storeId);
        });
      },
      targetOrderConditions,
      newOrderCondition,
      isAddOrderConditionOpen,
      store?.id,
    );
  const _getTranslationsCollapsable = () =>
    getTranslationsCollapsable(
      targetAddition,
      setTargetAddition,
      isTranslationsOpen,
      setIsTranslationsOpen,
      true,
      true,
      false,
      userLocale,
    );

  const _getOrderConditionsCollapsable = () =>
    getOrderConditionsCollapsable(
      targetOrderConditions,
      setTargetOrderConditions,
      isOrderConditionsOpen,
      setIsOrderConditionsOpen,
      userLocale,
      isSubmitting,
      intl,
      isAddOrderConditionOpen,
      setIsAddOrderConditionOpen,
      newOrderCondition,
      setNewOrderCondition,
      null,
      null,
      selectedOrderCondition,
      setSelectedOrderCondition,
    );

  const _getOrderConditionsCollapsableGroupEntry = () =>
    getOrderConditionsCollapsable(
      targetGroupEntryOrderConditions,
      setTargetGroupEntryOrderConditions,
      isOrderConditionsGroupEntryOpen,
      setIsOrderConditionsGroupEntryOpen,
      userLocale,
      isSubmitting,
      intl,
      isAddOrderConditionGroupEntryOpen,
      setIsAddOrderConditionGroupEntryOpen,
      newOrderConditionGroupEntry,
      setNewOrderConditionGroupEntry,
      'orderConditionsGroupEntryTitle',
      null,
      selectedOrderCondition,
      setSelectedOrderCondition,
    );

  useEffect(() => {
    if (isOpen) {
      if (addition) {
        setIsActive(addition?.isActive);
      }
      setTargetAddition(
        (addition && {
          ...addition,
          groupIds:
            additionGroups &&
            additionGroups
              ?.filter((group) =>
                group?.entries.some(
                  (entry) => entry.addition.id === addition?.id,
                ),
              )
              ?.map((group) => group.id),
          // ingredientIds: extractIds(addition.ingredients),
          preferenceIds: extractIds(addition.preferences),
          allergenIds: extractIds(addition.allergens),
        }) ||
          {},
      );
      setIsPreSelected(groupEntry?.isPreSelected || false);
      setTargetOrderConditions(addition?.orderConditions);
      setTargetGroupEntryOrderConditions(groupEntry?.orderConditions);
    } else {
      // reset modal on closing
      setTargetAddition({});
    }
  }, [addition, isOpen]);

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={_closeModalSafely}
      title={intl.formatMessage({
        id: isEditMode ? 'editAdditionTitle' : 'createNewAdditionTitle',
      })}
      footer={
        <div className="align-content-center">
          <SaveSubmitButton
            data-testid="submitButtonAddition"
            className="m-auto"
            isSubmitting={isSubmitting}
            onClick={() => formRef?.current.handleSubmit()}
          />
        </div>
      }
    >
      <div className="px-1">
        <AvForm ref={formRef} onSubmit={_handleSubmit} disabled={isSubmitting}>
          <div className="mt-1">
            <LabeledToggle
              disabled={isSubmitting}
              checked={isActive}
              onClick={() => setIsActive(!isActive)}
              wrapperClassName="d-flex align-content-center justify-content-between mt-2 mb-2"
              headingMessageId="isActiveLabel"
              headingClassName="d-block black"
            />
            <LocalizedNameField
              data-testid="additionNameInput"
              object={targetAddition}
              locale={userLocale}
              required
            />
            <LocalizedDescriptionField
              data-testid="descriptionInput"
              object={targetAddition}
              locale={userLocale}
            />
            <Row>
              <Col xs={6} className="pr-50">
                <FormattedNumberField
                  propName="priceInhouse"
                  object={targetAddition}
                  allowNegativePrice
                  suffixSign={getCurrencySuffix(store?.currency)}
                />
              </Col>
              <Col xs={6} className="pl-50">
                <TaxInhouseField
                  data-testid="taxInhouse"
                  object={targetAddition}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={6} className="pr-50">
                <FormattedNumberField
                  propName="priceTakeaway"
                  object={targetAddition}
                  allowNegativePrice
                  suffixSign={getCurrencySuffix(store?.currency)}
                />
              </Col>
              <Col xs={6} className="pl-50">
                <TaxTakeawayField
                  data-testid="taxTakeaway"
                  object={targetAddition}
                />
              </Col>
            </Row>
            <KcalField object={targetAddition} locale={userLocale} />
            <DropdownField
              values={targetAddition?.groupIds || []}
              propertyName="groupIds"
              options={additionGroups}
              getOptionValue={(additionGroup) => additionGroup?.id}
              getOptionLabel={(additionGroup) =>
                getLocalizedName(additionGroup, intl.locale)
              }
              isMulti={true}
              placeholderMessageId="itemAdditionGroupLabel"
              labelMessageId="itemAdditionGroupLabel"
              isDisabled={isSubmitting}
            />
            {/* <IngredientsField
              object={targetAddition}
              setter={setTargetAddition}
              options={allIngredients}
              isDisabled={isSubmitting}
            /> */}
            <AllergensField
              object={targetAddition}
              setter={setTargetAddition}
              options={allAllergens}
              isDisabled={isSubmitting}
            />
            <PreferencesField
              object={targetAddition}
              setter={setTargetAddition}
              options={allPreferences}
              isDisabled={isSubmitting}
            />
            <AdditivesField
              object={targetAddition}
              setter={setTargetAddition}
              options={allAdditives}
              isDisabled={isSubmitting}
            />
            {anyConfigRequiresAdditionMapping(store) && (
              <PosIntegrationRefField
                placeholder={intl.formatMessage({
                  id: 'selectPosIntegrationRefLabel',
                })}
                type="itemAddition"
                propertyName="posIntegrationRef"
                object={targetAddition}
                setter={setTargetAddition}
              />
            )}
            {_getTranslationsCollapsable()}
            {_getOrderConditionsCollapsable()}

            {groupEntry && (
              <Collapse
                isOpen={isItemAdditionGroupEntryOpen}
                setIsOpen={setIsItemAdditionGroupEntryOpen}
                titleId="itemAdditionGroupEntryLabel"
              >
                <div>
                  <div className="d-flex justify-content-between align-items-center">
                    <Alert className="d-flex p-50 mb-0" color="warning">
                      <span className="font-small-3">
                        <FormattedMessage
                          id="itemAdditionGroupEntryWarning"
                          values={{
                            additionGroup: getLocalizedName(additionGroup),
                          }}
                        />
                      </span>
                    </Alert>
                    <span className="font-medium-1"></span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center my-1">
                    <LabeledToggle
                      checked={isPreSelected}
                      onClick={() => setIsPreSelected(!isPreSelected)}
                      wrapperClassName="d-flex align-content-center justify-content-between mb-2"
                      headingClassName="font-medium-1 dark"
                      headingMessageId="isAdditionPreSelectedTitle"
                      subHeadingMessageId="isAdditionPreSelectedSubtitle"
                    />
                  </div>
                  {_getOrderConditionsCollapsableGroupEntry()}
                </div>
              </Collapse>
            )}
          </div>
        </AvForm>
      </div>
    </ModalSheet>
  );
};

const mapStateToProps = (state) => ({
  isCreateAdditionModalOpen: state.modals.isCreateAdditionModalOpen,
  isEditAdditionModalOpen: state.modals.isEditAdditionModalOpen,
  createAdditionModalData: state.modals.createAdditionModalData,
  editAdditionModalData: state.modals.editAdditionModalData,
  allAllergens: state.store.foodAllergens,
  allPreferences: state.store.foodPreferences,
  allIngredients: state.store.foodIngredients,
  allAdditives: state.store.foodAdditives,
  store: state.store.store,
  additionGroups: state.store.additionGroups,
  foodItemAdditions: state.store.foodItemAdditions,
  me: state.me.me,
});

export default connect(mapStateToProps, {
  setIsCreateAdditionModalOpen,
  setIsEditAdditionModalOpen,
  fetchFoodItemAdditions,
  fetchAdditionGroups,
  fetchMenuItems,
  fetchItemDatas,
  fetchMenuEntries,
})(injectIntl(CreateOrEditItemAdditionModal));
